export default function guest({ next, store }) {
  const isAuth = window.localStorage.getItem("_AUTH_");

  if (isAuth && !store.getters.isProfileLoaded) {
    store
      .dispatch("fetchProfile")
      .then(() => {
        if (store.getters.isProfileLoaded) {
          next({ name: "Dashboard" });
        } else {
          store.dispatch("logout");
          next();
        }
      })
      .catch(() => {});
  } else {
    next();
  }
}
